import { CalendarAppointmentEvent } from 'components/mrp/components/Calendar/Calendar.types';
import { CalendarPosition } from '../CalendarNavigationHandler.types';
import dayjs from 'dayjs';

export const getClosestCell = ({
  event,
  timeStep
}: {
  event?: CalendarAppointmentEvent;
  timeStep: number;
}): CalendarPosition | undefined => {
  if (!event) return;

  const date = dayjs(event.start);
  const totalMinutes = date.hour() * 60 + date.minute();
  const flooredMinutes = Math.floor(totalMinutes / timeStep) * timeStep;

  const newDate = date.startOf('day').add(flooredMinutes, 'minute');

  return {
    calendarId: event.calendarId,
    date: newDate
  };
};
